import {
  Button,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
  Textarea,
} from '@/components'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { useRedis } from '@/hooks/useRedis'
import commonUtils from '@/utils/commonUtils'
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Col } from 'styled-bootstrap-grid'

interface Data {
  // rnum: number
  cmpnyCd: string
  logId: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  siteType: string
  siteTypeNm: string
  logLayer: string
  logLayerNm: string
  logDate: string
  logTime: string
  logType: string
  logTypeNm: string
  clientIp: string
  logMsg: string
  remark: string
  stackTrace: string
}

const DetailComLog: React.FC = () => {
  const axios = useAxios();
  const navigate = useNavigate();
  const location = useLocation();
  const { showAlert, showConfirm } = useDialog();

  const { getComCodeValue } = useRedis();

  const [requestData] = useState({
    logId: location.state?.logId || '',
  });

  const [log, setLog] = useState<Data>({
    cmpnyCd: '',
    logId: '',
    regId: '',
    regDate: '',
    updId: '',
    updDate: '',
    siteType: '',
    siteTypeNm: '',
    logLayer: '',
    logLayerNm: '',
    logDate: '',
    logTime: '',
    logType: '',
    logTypeNm: '',
    clientIp: '',
    logMsg: '',
    remark: '',
    stackTrace: '',
  });

  const logMsgArea = useRef<HTMLTextAreaElement>(null);
  const stackTraceArea = useRef<HTMLTextAreaElement>(null);

  const getLogDetail = async () => {
    try {
      const response = await axios.post('/log/detail', {
        logId: requestData.logId,
      })
      // TODO 성공 실패 관련해서 실패코드가 업무별로 있는게 ..
      const log = response.data.data.log
      if (log) {
        log.siteTypeNm = getComCodeValue('SITE_TYPE', log.siteType)?.codeNm || '';
        log.logTypeNm = getComCodeValue('LOG_TYPE', log.logType)?.codeNm || '';
        log.logLayerNm = getComCodeValue('LOG_LAYER', log.logLayer)?.codeNm || '';
        setLog(log)
      }
    } catch (error) {
      console.error('Error fetching terms info:', error)
    }
  }

  const resizeTextarea = (refArea:any) => {
    if(refArea && refArea.current){

      refArea.current.style.height = 'auto';
      refArea.current.style.height = `${refArea.current.scrollHeight > 500 ? 500 : refArea.current.scrollHeight}px`;
    }

  }

  useEffect(() => {
    if(log){
      resizeTextarea(logMsgArea);
      resizeTextarea(stackTraceArea);
    }
  }, [log]);

  useEffect(() => {
    if (!!requestData.logId) {
      // 파라미터로 전달된 약관ID값이 있으면 수정, 없으면 등록
      getLogDetail();
    }else{
      showAlert({
        message:'잘못된 접근입니다.',
        onClose() {
          navigate('/comLog', {state: {searchData : location.state?.searchData}});
        },
      })
    }
  }, [])
  return (
    <>
      <div style={{ width: '100%', height: '100%', marginTop: '50px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <p style={{ marginLeft: '20px', fontSize: '20px' }}>로그상세</p>
          <FlexWrapper gap="20px">
            <Button
              onClick={() =>
                showConfirm({
                  title: '로그관리 화면으로 이동할까요?',
                  onConfirm() {
                    navigate('/comLog', {state: {searchData : location.state?.searchData, page: location.state?.page || 1, perPage: location.state?.perPage || 10}});
                  },
                })
              }
              color="neverbe"
              variant="outlined"
            >
              목록
            </Button>
          </FlexWrapper>
        </div>
      </div>
      <Container>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="logId">
                로그ID
              </Label>
              <Input
                id="logId"
                name="logId"
                type="text"
                // placeholder="약관코드는 자동 생성됩니다."
                maxLength={10}
                value={log.logId}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="logDate">
                로그발생일시
              </Label>
              <Input
                id="logDate"
                name="logDate"
                type="text"
                placeholder=""
                maxLength={3}
                value={commonUtils.formatDate(log.logDate+log.logTime, true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="siteTypeNm">
                사이트유형
              </Label>
              <Input
                id="siteTypeNm"
                name="siteTypeNm"
                type="text"
                maxLength={10}
                value={log.siteTypeNm || log.siteType}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="logLayer">
                레이어
              </Label>
              <Input
                id="logLayer"
                name="logLayer"
                type="text"
                placeholder=""
                maxLength={3}
                value={log.logLayerNm || log.logLayer}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="logType">
                로그유형
              </Label>
              <Input
                id="logType"
                name="logType"
                type="text"
                placeholder=""
                maxLength={3}
                value={log.logTypeNm || log.logType}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="logMsg">
                메세지
              </Label>
              <Textarea
                id="logMsg"
                name="logMsg"
                value={log.logMsg}
                disabled={true}
                height={'100%'}
                ref={logMsgArea}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col style={{height: 'maxContent'}}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="stackTrace">
                스택트레이스
              </Label>
              <Textarea
              // TODO 높이값 
                id="stackTrace"
                name="stackTrace"
                value={log.stackTrace}
                disabled={true}
                height={'100%'}
                ref={stackTraceArea}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="remark">
                비고
              </Label>
              <Textarea
                id="remark"
                name="remark"
                // placeholder="약관코드는 자동 생성됩니다."
                value={log.remark}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regId">
                등록자
              </Label>
              <Input
                id="regId"
                name="regId"
                type="text"
                placeholder=""
                maxLength={100}
                value={log.regId}
                disabled={true}
                // onChange={handleInputChange}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regDate">
                등록일시
              </Label>
              <Input
                id="regDate"
                name="regDate"
                type="text"
                placeholder=""
                maxLength={100}
                value={commonUtils.formatDate(log.regDate, true)}
                disabled={true}
                // onChange={handleInputChange}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updId">
                수정자
              </Label>
              <Input
                id="updId"
                name="updId"
                type="text"
                placeholder=""
                maxLength={100}
                value={log.updId}
                disabled={true}
                // onChange={handleInputChange}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updDate">
                수정일시
              </Label>
              <Input
                id="updDate"
                name="updDate"
                type="text"
                placeholder=""
                maxLength={100}
                value={commonUtils.formatDate(log.updDate, true)}
                disabled={true}
                // onChange={handleInputChange}
              />
            </FormGroup>
          </Col>
        </Row>
      </Container>
    </>
  )
}
export default DetailComLog;
